import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/Nippon/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Nippon/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/sections/project-detail-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/NewsCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/PageHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/ProjectStage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/RelatedProject.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/ServiceCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Nippon/frontend/src/components/shared/ServiceCategory.tsx");
